module.exports = " <div> <div class=mask v-show=visible></div> <div class=modal v-show=visible> <i v-on:click=\"handleActions('cancel')\" class=\"close paco icon-close\"></i> <div v-html=message></div> <button v-on:click=\"handleActions('confirm')\" class=\"btn primary\">{{btn}}</button> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/model.vue
// module id = 137
// module chunks = 1